export default "/images/010a49d152fc918d564970efd100080a.avif";